import Showcase from './showcase/showcase-layout';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import MobileSuggestions from './showcase/mobile-suggestions';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Showcase />} />
      <Route path="/suggestions" element={<MobileSuggestions />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
